import api from './api';

export const createCompositionReviewService = (compositionId: number) =>
  api(`/api/v1/compositions/${compositionId}/create_review/`, {
    method: 'post',
  });
